import { m } from 'framer-motion';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
// import { webalize } from 'webalize';
//  import { varFade } from '../../animate';
import MotionContainer from '../../animate/MotionContainer';
import ItemCard from '../../custom/Cards/ItemCard';
import SimilarCarousel from './SimilarCarousel';
import COLabel from '../../custom/Labels/COLabel';
import useLocales from '../../../hooks/useLocales';
import useWindowSize from '../../../hooks/useWindowSize';
import useResponsive from '../../../hooks/useResponsive';
import ShowMore from '../../custom/Labels/ShowMore';
import { dispatch, useSelector } from '../../../redux/store';
import { addToFavourites } from '../../../redux/slices/favourites';

SimilarObjects.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  redirect: PropTypes.string,
  search: PropTypes.string,
  onlyWithImage: PropTypes.bool,
  onlyDownloadable: PropTypes.bool,
  searchSimilarNames: PropTypes.bool,
  urlfilter: PropTypes.any,
  currentCoName: PropTypes.string,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(6, 0),
  backgroundColor: theme.palette.background.paper,
}));

// ----------------------------------------------------------------------

export default function SimilarObjects({
  title,
  items,
  redirect,
  search,
  onlyWithImage = true,
  onlyDownloadable = false,
  searchSimilarNames = false,
  urlfilter = {},
  currentCoName = '',
}) {
  const navigation = useNavigate();
  const { translate } = useLocales();
  const [loopForTiles, setLoopForTiles] = useState([0, 1, 2]);
  const { favourites } = useSelector((state) => state.favourites);
  const windowSize = useWindowSize();
  const isMobile = useResponsive('down', 'sm');
  useEffect(() => {
    if (windowSize === 'xs' && loopForTiles.length !== 1) {
      setLoopForTiles([0]);
    } else if (windowSize === 'sm' && loopForTiles.length !== 2) {
      setLoopForTiles([0, 1]);
    } else if (windowSize === 'lg' && loopForTiles.length !== 3) {
      setLoopForTiles([0, 1, 2]);
    }
  }, [windowSize, loopForTiles]);

  const redirectFun = () => {
    navigation(
      `${redirect}?search=${search}&sort=rank&sortDirection=1&filter=%7B"onlyWithImage"%3A${onlyWithImage}%2C"onlyDownloadable"%3A${onlyDownloadable}%7D&page=1&searchByKeywords=true&searchSimilarNames=true`
    );
  };

  const heart = (newItem) => {
    dispatch(addToFavourites({ ...newItem, type: 'object' }));
  };

  const itemsShow = loopForTiles.map((number) => (
    <Grid key={number} xs={12} sm={6} md={4} item>
      {items.map((item, idx) => {
        if (idx % loopForTiles.length === number) {
          // Update f.index here
          if (urlfilter === null) {
            urlfilter = {};
          }
          if (searchSimilarNames !== false) {
            urlfilter.searchSimilarNames = searchSimilarNames;
            urlfilter.index = idx;
          }

          const f =
            searchSimilarNames !== false ? `?url=${encodeURIComponent(JSON.stringify(urlfilter))}&fromPage=ko` : '';
          const o = currentCoName !== '' ? `/${encodeURIComponent(currentCoName.replaceAll('.', ''))}` : '';
          return (
            <div key={idx}>
              <ItemCard
                img={
                  // eslint-disable-next-line no-nested-ternary
                  item.thumbnail.includes('http')
                    ? item.thumbnail
                    : item.thumbnail !== undefined && item.thumbnail !== ''
                    ? `${process.env.REACT_APP_API_URL}/image/download/${item.thumbnail}?sizeIndex=0`
                    : ''
                }
                favorite={favourites.findIndex((s) => s.key === item.key) !== -1}
                width={12}
                fixedWidth
                heartAction={() => heart(item)}
                action={`${redirect}/${item.culturalObjectKey || item.key}${o}${f}`}
              >
                <COLabel
                  title={item.name}
                  author={item.preferredAuthor?.[0]}
                  age={item.displayOriginDate}
                  category={item.categories[0]?.name || ''}
                />
              </ItemCard>
            </div>
          );
        }
        return null; // Return null for items that don't match the condition
      })}
    </Grid>
  ));

  return (
    <>
      {isMobile && items.length > 0 && (
        <RootStyle className="hidden-print">
          <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
            <m.div /* variants={varFade().inUp} */>
              <Typography variant="h4" style={{ marginBottom: '24px' }}>
                {translate(title)}
              </Typography>
              <SimilarCarousel items={items} redirect={redirect} onClick={redirectFun} />
            </m.div>
          </Container>
        </RootStyle>
      )}
      {!isMobile && items.length > 0 && (
        <RootStyle className="hidden-print">
          <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
            <m.div /* variants={varFade().inUp} */>
              <Typography variant="h4">{translate(title)}</Typography>
              <Grid container spacing={'24px'} style={{ marginTop: '12px' }}>
                {itemsShow}
              </Grid>
            </m.div>
            <ShowMore text="objects.showMore" onClick={redirectFun} />
          </Container>
        </RootStyle>
      )}
    </>
  );
}
